module.exports = new __parcel__URL__("first-place.3146ad0f.svg").toString();